import "intl";
import "intl/locale-data/jsonp/id";
import "intl/locale-data/jsonp/en";
import "react-calendar/dist/Calendar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "@/i18n";
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "@mui/material/styles";
import { THEME } from "@/theme";

import SentryWrapper from "./components/sentryWrapper";
import { Provider } from "react-redux";
import createStore from "@/store";
import { createBrowserHistory } from "history";
import { PersistGate } from "redux-persist/integration/react";
import ApolloClient from "@/components/apolloClient";
import { ApolloProvider } from "@apollo/client/react";
import MainRoutes from "@/routes";
import { Router } from "react-router-dom";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import reportWebVitals from "./reportWebVitals";

const { store, persistor } = createStore();
const history = createBrowserHistory();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <ThemeProvider theme={THEME}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SentryWrapper>
          <Provider store={store}>
            <ApolloClient>
              {(client) => (
                <ApolloProvider client={client}>
                  <PersistGate loading={null} persistor={persistor}>
                    <Router history={history}>
                      <MainRoutes />
                    </Router>
                  </PersistGate>
                </ApolloProvider>
              )}
            </ApolloClient>
          </Provider>
        </SentryWrapper>
      </LocalizationProvider>
    </ThemeProvider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
